$(function ($) {

  // On scroll
  setTimeout(function () {
    onScroll();
    $(document).on('scroll', function () {
      onScroll();
    });
  }, 10);
  let endPosition = 0;

  
  $('.hint-toggle').on('click', function(e) {
    e.preventDefault();
    $(this).closest('.hint').siblings('.hint').removeClass('is-open');
    $(this).closest('.hint').toggleClass('is-open');
  });

  $(document).mouseup(function(e) {
    const container = $('.hint');
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      container.removeClass('is-open');
    }
  });

  if ($('.bordered-layout').length > 0 && $('.article-header').length > 0) {
    endPosition = $('.article-header').offset().top + $('.article-header').innerHeight() + $('.bordered-layout .main-column').innerHeight();
  }

  if ($('.article-special').length > 0) {
    endPosition = $('.article-special').innerHeight();
  }

  $('.close-fixed').on('click', function(e) {
    e.preventDefault();
    $(this).closest('.visible').removeClass('visible');
    $(this).closest('.fixed').removeClass('fixed').addClass('closed');
    $('.pause-audio').trigger('click');
  });

  $('.play-audio').on('click', function(e) {
    e.preventDefault();
    $('.visible').removeClass('visible');
    $('.pause-audio').trigger('click');
    let wrapper = $(this).closest('.audio-block-wrapper');
    wrapper.find('audio').trigger('play');
    wrapper.find('.play-audio').hide();
    wrapper.find('.pause-audio').show();
    wrapper.find('.sticky-audio').addClass('visible');
    stopVideo();
  });

  $('.pause-audio').on('click', function(e) {
    e.preventDefault();
    let wrapper = $(this).closest('.audio-block-wrapper');
    wrapper.find('audio').trigger('pause');
    wrapper.find('.pause-audio').hide();
    wrapper.find('.play-audio').show();
  });

  const audioFiles = [...document.getElementsByTagName('audio')];

  if (audioFiles.length > 0) {
    audioFiles.forEach((audio, index) => {
      let audioEl = $('audio').eq(index).closest('.audio-block-wrapper');
      audio.addEventListener('loadedmetadata', function(_event) {
        const totalTime = audio.duration;
        const minutes = "0" + Math.floor(totalTime / 60);
        const seconds = "0" + Math.floor(totalTime % 60);
        const totalText = minutes.substr(-2) + ":" + seconds.substr(-2);
        audioEl.find('.total-time').text(totalText);
      });

      audio.addEventListener('timeupdate', function () {
        const currentTime = audio.currentTime || 0;
        const duration = audio.duration || 0;
        const progress = (currentTime / duration * 100).toFixed(1);

        const minutes = "0" + Math.floor(currentTime / 60);
        const seconds = "0" + Math.floor(currentTime % 60);
        const currentText = minutes.substr(-2) + ":" + seconds.substr(-2);
        audioEl.find('.current-time').text(currentText);
        audioEl.find('.audio-progress').css('width', progress + '%')
      }, false);

      audioEl.find('.audio-bar').on('click', function(e){
        const barWidth = $(this).width();
        const duration = audio.duration || 0;
        const cursorPosition = e.pageX - $(this).offset().left;
        const progress = (cursorPosition / barWidth * 100).toFixed(1);
        audioEl.find('.audio-progress').css('width', progress + '%');
        audio.currentTime = cursorPosition / barWidth * duration;
      });

    });
  }

  function onScroll() {
    let position = $(window).scrollTop();

    // Fixed share buttons
    if ($('.article-socials').length > 0) {
      if (position + $(window).height() > endPosition) {
        $('.article-socials').addClass('hidden-mobile');
      } else {
        $('.article-socials').removeClass('hidden-mobile');
      }
    }

  }

});
